import { render, staticRenderFns } from "./dashboard-top-shipments.vue?vue&type=template&id=362a3e05&"
import script from "./dashboard-top-shipments.vue?vue&type=script&lang=js&"
export * from "./dashboard-top-shipments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports